import React, { Component, useState } from "react";
import Slider from "react-slick";

const AdSlider = (props) => {

    const settings = {
        infinite: true,
        autoplay: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
    };

    return (
        <div className={props.classImg}>
            <Slider {...settings}>
                {props.srcData.map(item => {
                    return <div className={"slidertem"}>
                        <img src={item} />
                    </div>
                })}
            </Slider>
        </div>
    );
}


export default AdSlider;